export const socialLinks = [
	{
		id: 1,
		name: 'Facebook',
		icon: 'facebook',
		url: 'https://www.facebook.com/share/1GR8Uw3pbg/?mibextid=wwXIfr',
	},
	{
		id: 2,
		name: 'Instagram',
		icon: 'instagram',
		url: 'https://www.instagram.com/mfd_solutions?igsh=MXZjemkwaTA0ZmZ5bA==',
	},
	{
		id: 3,
		name: 'Google Reviews',
		icon: 'google',
		url: 'https://share.google/FA0NB2ejt9F4Jl9bl',
	},
];
